module.exports = __webpack_public_path__ + "images/graphic-panel-mobile_e83682786890b13f6be27d5219eafd38.png";